module.exports = function getResource(label) {
    const resources = {
        signIn: 'Ouvrir une session',
        sigInToSeeItems: 'Ouvrez une session pour voir les articles que vous pourriez avoir ajoutés précédemment.',
        seeSamplesRewardsPromotions: 'Voir les échantillons, les récompenses et les promotions dans le',
        basket: 'panier',
        dcTotal: 'Faites livrer ',
        basketTotal: 'Sous-total ',
        reserveTotal: 'Réservation et ramassage ',
        bopisTotal: 'Achat en ligne et ramassage ',
        checkout: 'Voir le panier et passer à la caisse',
        emptyBasket: 'Votre panier est vide.',
        item: 'article',
        or: 'ou',
        shopNewArrivals: 'Découvrir les nouveautés',
        viewAll: 'Tout afficher',
        freeShipping: 'Expédition gratuite',
        createAccount: 'Créer un compte',
        basketHeader: 'Faites livrer',
        reserveHeader: 'Réservation et ramassage',
        bopisHeader: 'Achat en ligne et ramassage',
        sameDayDelivery: 'Livraison le jour même',
        standardDelivery: 'Standard',
        getBackToYourBasket: 'Retourner au panier'
    };

    return resources[label];
};
